export default __webpack_public_path__ + "static/media/pdf.23386427.svg";